<p-table [value]="shareholders" responsiveLayout="stack">
    <ng-template pTemplate="header">
        <tr>
            <th pResizableColumn scope="col">#</th>
            <th pResizableColumn scope="col">Imię/imiona</th>
            <th pResizableColumn scope="col">Nazwisko</th>
            <th pResizableColumn scope="col">NIP</th>
            <th pResizableColumn scope="col">PESEL</th>
            <th *ngIf="!peselsOnly" pResizableColumn scope="col">Rodzaj dokumentu</th>
            <th *ngIf="!peselsOnly" pResizableColumn scope="col">Numer dokumentu</th>
            <th pResizableColumn scope="col">Zaświadczenie z KRK</th>
            <th pResizableColumn scope="col"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td class="text-align-center red" colspan="9">
                Brak członków zarządu. Nie można złożyć wniosku. Skontaktuj się z KRS aby poprawić dane.
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-shareholder let-ri="rowIndex">
        <tr>
            <td><span class="p-column-title">#</span>{{ri+1}}</td>
            <td><span class="p-column-title">Imię/imiona</span>{{shareholder.personalData.firstname}}</td>
            <td><span class="p-column-title">Nazwisko</span>{{shareholder.personalData.surname}}</td>
            <td><span class="p-column-title">NIP</span>{{shareholder.nip}}</td>
            <td><span class="p-column-title">PESEL</span>{{shareholder.personalData.pesel}}</td>
            <td *ngIf="!peselsOnly"><span class="p-column-title">Rodzaj dokumentu</span>{{identityTypesMap.get(shareholder.personalData.identityType)}}</td>
            <td *ngIf="!peselsOnly"><span class="p-column-title">Numer dokumentu</span>{{shareholder.personalData.identityValue}}</td>
            <td>
                <span class="p-column-title">Zaświadczenie z KRK</span>
                <i *ngIf="!shareholder.personalData.krkId" class="pi pi-exclamation-circle p-error" aria-hidden="true"></i>
                {{krkMap.get(shareholder.personalData.krkId)?.name}}
            </td>
            <td class="text-align-right">
                <p-button pRipple type="button" icon="pi pi-pencil" (onClick)="onShareholderRowEdit(shareholder, ri)" styleClass="p-button-warning"></p-button>&nbsp;
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="Edytuj członka zarządu"
          [(visible)]="displayShareholderAdding"
          [modal]="true"
          [draggable]="false"
          [resizable]="false"
          styleClass="w-11 md:wp-6"
          (onHide)="onDialogClosed()">
    <form #addShareholderForm="ngForm">
        <ul class="list-none p-0 m-0">
            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-full md:wp-4 font-medium">Imię/imiona</div>
                <div *ngIf="!alreadyFilled" class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    <p-inputMask [mask]="firstNameMask" [placeholder]="firstNamePlaceholder"
                                 [(ngModel)]="shareholder.personalData!.firstname" [required]="true" autocomplete="off"
                                 characterPattern="[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ]" minlength="2" #name="ngModel" name="name"
                                 />
                    <small *ngIf="name.invalid && (name.dirty ||name.touched)" class="p-error">
                        <div *ngIf="name?.errors?.['required']">
                            Imię jest wymagane.
                        </div>
                        <div *ngIf="name.errors?.['minlength']">
                            Imię musi mieć co najmniej 2 znaki.
                        </div>
                    </small>
                </div>
                <div *ngIf="alreadyFilled" class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    {{shareholder.personalData!.firstname}}
                </div>
            </li>
            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-full md:wp-4 font-medium">Nazwisko</div>
                <div *ngIf="!alreadyFilled" class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    <p-inputMask [mask]="surnameMask" [placeholder]="surnamePlaceholder"
                                 [(ngModel)]="shareholder.personalData!.surname" [required]="true"
                                 minlength="2" #surname="ngModel" name="surname" autocomplete="off"
                                 characterPattern="[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ]"/>
                    <small *ngIf="surname.invalid && (surname.dirty ||surname.touched)" class="p-error">
                        <div *ngIf="surname?.errors?.['required']">
                            Nazwisko jest wymagane.
                        </div>
                        <div *ngIf="surname.errors?.['minlength']">
                            Nazwisko musi mieć co najmniej 2 znaki.
                        </div>
                    </small>
                </div>
                <div *ngIf="alreadyFilled" class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    {{shareholder.personalData!.surname}}
                </div>
            </li>
            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-full md:wp-4 font-medium">NIP
                    <i class="pi pi-info-circle" pTooltip="Jeśli nie posiadasz NIP-u osoby fizycznej zaznacz odpowiedni checkbox." aria-hidden="true"></i>
                </div>
                <div class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    <p-inputMask mask="9999999999" [(ngModel)]="shareholder.nip"
                                 [unmask]=true #nip="ngModel" [disabled]="shareholder.noNip!"
                                 [required]="true" [autoClear]=false [minlength]="10"
                                 name="nip" autocomplete="off" nipValidator>
                    </p-inputMask>
                    <small *ngIf="nip.invalid && (nip.dirty ||nip.touched)" class="p-error">
                        <div *ngIf="nip?.errors?.['required']">
                            Numer NIP jest wymagany.
                        </div>
                        <div *ngIf="nip.errors?.['nip']">
                            Niepoprawny numer NIP
                        </div>
                        <div *ngIf="nip?.errors?.['minlength']">
                            Numer NIP musi składać się z 10 cyfr
                        </div>
                    </small>
                </div>
            </li>

            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-full md:wp-4 font-medium">Brak numeru NIP</div>
                <div class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    <p-checkbox [(ngModel)]="shareholder.noNip" [binary]="true" (onChange)="noNipChanged($event.checked)" name="noNip"></p-checkbox>
                </div>
            </li>

            <li *ngIf="!noPesel" class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-full md:wp-4 font-medium">PESEL</div>
                <div *ngIf="!alreadyFilled && !shareholder.personalData!.krkId" class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    <p-inputMask [mask]="peselMask" [placeholder]="peselPlaceholder"
                                 [(ngModel)]="shareholder.personalData!.pesel" #pesel="ngModel"
                                 [required]="true" [autoClear]=false [minlength]="11"
                                 peselValidator name="pesel" autocomplete="off"></p-inputMask>
                    <small *ngIf="pesel.invalid && (pesel.dirty || pesel.touched)" class="p-error">
                        <div *ngIf="pesel?.errors?.['required']">
                            PESEL jest wymagany
                        </div>
                        <div *ngIf="pesel.errors?.['pesel']">
                            Niepoprawny numer PESEL
                        </div>
                        <div *ngIf="pesel?.errors?.['minlength']">
                            Numer PESEL musi składać się z 11 cyfr
                        </div>
                    </small>
                </div>
                <div *ngIf="alreadyFilled || shareholder.personalData!.krkId" class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    {{shareholder.personalData!.pesel}}
                </div>
            </li>
            <li *ngIf="noPesel" class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-full md:wp-4 font-medium">Rodzaj dokumentu</div>
                <div class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    <p-dropdown [options]="identityTypes" [(ngModel)]="shareholder.personalData!.identityType" placeholder="Wybierz rodzaj dokumentu" optionLabel="key" optionValue="value" name="idType" #idType="ngModel" [required]="true" class="p-fluid"></p-dropdown>
                    <small *ngIf="idType.invalid && (idType.dirty || idType.touched)" class="p-error">
                        <div *ngIf="idType?.errors?.['required']">
                            Rodzaj dokumentu jest wymagany
                        </div>
                    </small>
                </div>
            </li>
            <li *ngIf="noPesel" class="flex align-items-center py-3 px-2 border-top-1  border-bottom-1 surface-border flex-wrap">
                <div class="text-500 w-full md:wp-4 font-medium">Seria i numer</div>
                <div class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    <input type="text" [(ngModel)]="shareholder.personalData!.identityValue" class="p-inputtext-sm" pInputText  name="idNumber" #idNumber="ngModel" required [pKeyFilter]="identityFilter"/>
                    <small *ngIf="idNumber.invalid && (idNumber.dirty || idNumber.touched)" class="p-error">
                        <div *ngIf="idNumber?.errors?.['required']">
                            Seria i numer dokumentu są wymagane
                        </div>
                    </small>
                </div>
            </li>
            <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-full md:wp-4 font-medium">Zaświadczenie z Krajowego Rejestru Karnego [ w formie pliku ZIP]*
                    <i class="pi pi-info-circle" pTooltip="Zaświadczenie z Krajowego Rejestru Karnego o niekaralności za przestępstwa, o których mowa w art. 59da ust. 2 pkt 1 ustawy z dnia 12 maja 2011 r. o kredycie konsumenckim w formacie zip (plik zip zawiera: XADES, dokument XML oraz dokument PDF) składa pośrednik kredytowy będący osobą fizyczną." aria-hidden="true"></i>
                </div>
                <div *ngIf="!alreadyFilled" class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    <p-fileUpload #krkForm mode="advanced" accept=".zip" [customUpload]="true" [auto]="true"
                                  (uploadHandler)="uploadHandler($event, krkForm)" chooseLabel="Dodaj plik"
                                  (onRemove)="fileRemove(krkForm)"
                                  [maxFileSize]=10000000
                                  invalidFileTypeMessageSummary="{0}: Niepoprawny typ pliku"
                                  invalidFileTypeMessageDetail="dopuszczalny typ: zip"
                                  invalidFileSizeMessageSummary="{0}: Przekroczony rozmiar pliku"
                                  invalidFileSizeMessageDetail="maksymalny rozmiar pliku: {0}">
                    </p-fileUpload>
                    <small *ngIf="krkError" class="p-error">
                        <div>
                            Plik KRK jest wymagany
                        </div>
                    </small>
                </div>
                <div *ngIf="alreadyFilled" class="text-900 w-full md:wp-8 md:flex-order-0 flex-order-1">
                    {{krkFile?.attachment?.name}}
                </div>
            </li>
        </ul>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-save"  label="Zapisz" (click)="saveShareholder()"></p-button>
    </ng-template>
</p-dialog>